import React from "react";

function matchMedia(query: string): MediaQueryList | null {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return null;
    }
    return window.matchMedia(query);
}

export function useMediaQuery(query: string) {
    const subscribe = React.useCallback(
        (callback: () => void) => {
            const mql = matchMedia(query);
            if (!mql) {
                return () => {};
            }

            mql.addEventListener("change", callback);
            return () => {
                mql.removeEventListener("change", callback);
            };
        },
        [query],
    );

    const getSnapshot = () => {
        const mql = matchMedia(query);
        return mql && mql.matches;
    };

    return React.useSyncExternalStore(subscribe, getSnapshot);
}
